import {
  SvgAccount,
  SvgAccountFilled,
  SvgApiKey,
  SvgApiKeyFilled,
  SvgConversation,
  SvgConversationFilled,
  SvgDashboard,
  SvgDashboardFilled,
  SvgDataApi,
  SvgDataApiFilled,
  SvgDictionary,
  SvgDictionaryFilled,
  SvgHome,
  SvgHomeFilled,
  SvgMessage,
  SvgMessageFilled,
  SvgOpenApi,
  SvgOpenApiFilled,
  SvgSetting,
  SvgSettingFilled,
  SvgTeam,
  SvgTeamFilled,
  SvgVisitors,
  SvgVisitorsFilled,
  SvgWand,
  SvgWandFilled,
  SvgWidget,
  SvgWidgetFilled,
  SvgAdminConsole,
  SvgDigitalHuman,
  SvgDigitalHumanFilled,
} from '@/components/Navbar/icon';
import { LinkItem, NavItem } from '@/types/nav-item';
import { IconLayoutGrid, IconLayoutGridFilled, IconShieldLock, IconTags, IconTagsFilled } from '@tabler/icons-react';

// 根据环境变量过滤抓网页模块
const linksFilter = ({ link }: LinkItem) => {
  // 如果没限制使用，全部返回
  if (import.meta.env.VITE_NO_API_DOCUMENT !== 'true') {
    return true;
  }

  // 如果限制了使用，过滤掉不展示
  if (link === 'https://platform.gbase.ai/docs') {
    return false;
  }

  return true;
};

// 根据配置变量过滤机器人导航菜单项
const botLinksFilter = (item: any) => {
  const env = (window as any).ENV;
  const isLocalMode = import.meta.env.VITE_MODE === 'local';

  // 过滤小部件嵌入功能
  if (env?.GBASE_SUPPORT_FRONTEND_HIDE_WIDGET_EMBED === 'true' && item.link && item.link.includes('/widget-embed')) {
    return false;
  }

  // 过滤在线访客功能
  if (env?.GBASE_SUPPORT_FRONTEND_HIDE_ONLINE_VISITORS === 'true' && item.link && item.link.includes('/visitors')) {
    return false;
  }

  // 如果是数字人菜单项且在本地部署模式，则过滤掉
  if (item.label === 'menu.bot.digital_human' && isLocalMode) {
    return false;
  }

  return true;
};

// 递归过滤导航项
const filterNavItems = (navItems: NavItem[]): NavItem[] => {
  return navItems
    .map((navItem) => ({
      ...navItem,
      item: navItem.item
        .map((item) => {
          if (item.children) {
            return {
              ...item,
              children: item.children.filter(botLinksFilter),
            };
          }
          return item;
        })
        .filter(botLinksFilter),
    }))
    .filter((navItem) => navItem.item.length > 0);
};

const isLocalMode = import.meta.env.VITE_MODE === 'local';
const rawLinks: (LinkItem | undefined)[] = [
  {
    label: 'menu.my_bots',
    link: '/bots',
    icon: SvgHome,
    activeIcon: SvgHomeFilled,
  },
  {
    label: 'menu.bot.data_sets',
    link: '/datasets',
    icon: SvgDataApi,
    activeIcon: SvgDataApiFilled,
  },
  // {
  //   label: 'Team',
  //   link: '/team',
  //   icon: SvgTeam,
  //   activeIcon: SvgTeamFilled,
  // },
  // {
  //   label: 'menu.create',
  //   link: '/create',
  //   icon: SvgCreate,
  //   activeIcon: SvgCreateFilled,
  // },

  // {
  //   label: 'menu.account',
  //   link: '/account',
  //   icon: SvgAccount,
  //   activeIcon: SvgAccountFilled,
  // },
  // API密钥入口已移至头像菜单中
  // {
  //   label: 'menu.api_keys',
  //   link: '/keys',
  //   icon: SvgApiKey,
  //   activeIcon: SvgApiKeyFilled,
  // },
  isLocalMode
    ? {
        label: 'menu.api_docs',
        // link: 'https://docs.gbase.ai/user-manual',
        link: '/GBase.Onprem.pdf',
        download: true,
        icon: SvgOpenApi,
        activeIcon: SvgOpenApiFilled,
      }
    : {
        label: 'menu.api_docs',
        link: 'https://docs.gbase.ai/user-manual',
        target: '_blank',
        icon: SvgOpenApi,
        activeIcon: SvgOpenApiFilled,
      },
  isLocalMode
    ? undefined
    : {
        label: 'menu.collaborative',
        link: '/collaborative',
        icon: SvgTeam,
        activeIcon: SvgTeamFilled,
      },
  // 消息中心已移至头像hover菜单中
  // {
  //   label: 'menu.api',
  //   icon: ApiKeyIcon,
  //   link: '',
  //   links: [
  //     {
  //       label: 'menu.api_keys',
  //       link: '/keys',
  //       // icon: IconCircleKey,
  //     },
  //     {
  //       label: 'menu.api_docs',
  //       link: 'https://platform.gbase.ai/docs',
  //       target: '_blank',
  //       // icon: IconFileDescription,
  //     },
  //   ],
  // },
];
let links: LinkItem[] = rawLinks.filter(Boolean) as LinkItem[];

export const navLinks = [
  {
    group: '',
    item: links.filter(Boolean).filter(linksFilter),
  },
];

export const collaborationLink: LinkItem = {
  label: 'menu.access',
  link: '/access',
  icon: SvgAccount,
  activeIcon: SvgAccountFilled,
};

export const adminConsoleLinks: LinkItem[] = [
  //   {
  //     label: 'adminConsole.adminConsole',
  //     link: '/admin-console',
  //     icon: SvgAdminConsole,
  //     activeIcon: SvgAdminConsole,
  //   },
  {
    label: 'adminConsole.enterprisePermissionManagement',
    link: '/new-admin-console',
    icon: SvgTeam,
    activeIcon: SvgTeamFilled,
  },
];

export const securityPolicyLink: LinkItem = {
  label: 'security_policy.menu',
  link: '/security-policy',
  icon: () => <IconShieldLock size={24} color="#667085" />,
  activeIcon: () => <IconShieldLock size={24} color="#7C68FB" />,
};

export const prefixId = ':id';
const botPrefix = '/bot/' + prefixId;

// 两级结构。并且包含标签管理入口
const dashboard: LinkItem = {
  label: 'menu.bot.dashboard',
  icon: () => <IconLayoutGrid size={24} color="#667085" />,
  activeIcon: () => <IconLayoutGridFilled size={24} color="#7C68FB" />,
  children: [
    {
      label: 'dashboard.overview',
      link: botPrefix + '/dashboard',
      icon: SvgDashboard,
      activeIcon: SvgDashboardFilled,
    },
    {
      label: 'menu.bot.tag_management',
      link: botPrefix + '/tag',
      permissionKey: isLocalMode ? '' : 'enable_question_tag',
      icon: () => <IconTags size={24} color="#667085" />,
      activeIcon: () => <IconTagsFilled size={24} color="#7C68FB" />,
    },
  ],
};

const rawBotLinks: NavItem[] = [
  {
    group: 'menu.bot.workshop',
    item: [
      dashboard,
      {
        label: 'menu.bot.live_visitors',
        link: botPrefix + '/visitors',
        icon: SvgVisitors,
        activeIcon: SvgVisitorsFilled,
      },
      {
        label: 'menu.bot.chat',
        link: botPrefix + '/chat',
        icon: SvgMessage,
        activeIcon: SvgMessageFilled,
      },
    ],
  },
  {
    group: 'CUSTOMIZATION',
    item: [
      {
        label: 'menu.bot.digital_human',
        link: botPrefix + '/digital-human',
        icon: SvgDigitalHuman,
        activeIcon: SvgDigitalHumanFilled,
        showBeta: true,
      },
      {
        label: 'menu.bot.widget_embed',
        link: botPrefix + '/widget-embed',
        icon: SvgWidget,
        activeIcon: SvgWidgetFilled,
      },
      {
        label: 'homepage.title',
        link: botPrefix + '/homepage',
        icon: SvgHome,
        activeIcon: SvgHomeFilled,
      },
      {
        label: 'menu.bot.records',
        link: botPrefix + '/records',
        icon: SvgConversation,
        activeIcon: SvgConversationFilled,
      },
    ],
  },
  {
    group: 'SETTINGS',
    item: [
      {
        label: 'menu.bot.settings',
        link: botPrefix + '/settings',
        icon: SvgSetting,
        activeIcon: SvgSettingFilled,
      },
    ],
  },

  {
    group: 'TRAINING',
    item: [
      {
        label: 'menu.bot.dictionary',
        link: botPrefix + '/dictionary',
        icon: SvgDictionary,
        activeIcon: SvgDictionaryFilled,
      },
    ],
  },
];

const assistPrefix = '/assist/' + prefixId;
const rawAssistLinks: NavItem[] = [
  {
    group: 'menu.bot.workshop',
    item: [
      {
        label: 'menu.bot.dashboard',
        icon: () => <IconLayoutGrid size={24} color="#667085" />,
        activeIcon: () => <IconLayoutGridFilled size={24} color="#7C68FB" />,
        children: [
          {
            label: 'dashboard.overview',
            link: assistPrefix + '/dashboard',
            icon: SvgDashboard,
            activeIcon: SvgDashboardFilled,
          },
          {
            label: 'menu.bot.tag_management',
            link: assistPrefix + '/tag',
            permissionKey: isLocalMode ? '' : 'enable_question_tag',
            icon: () => <IconTags size={24} color="#667085" />,
            activeIcon: () => <IconTagsFilled size={24} color="#7C68FB" />,
          },
        ],
      },
      {
        label: 'menu.bot.live_visitors',
        link: assistPrefix + '/visitors',
        icon: SvgVisitors,
        activeIcon: SvgVisitorsFilled,
      },
      {
        label: 'menu.bot.chat',
        link: assistPrefix + '/chat',
        icon: SvgMessage,
        activeIcon: SvgMessageFilled,
      },
    ],
  },
  {
    group: 'CUSTOMIZATION',
    item: [
      {
        label: 'menu.bot.digital_human',
        link: assistPrefix + '/digital-human',
        icon: SvgDigitalHuman,
        activeIcon: SvgDigitalHumanFilled,
        showBeta: true,
      },
      {
        label: 'menu.bot.widget_embed',
        link: assistPrefix + '/widget-embed',
        icon: SvgWidget,
        activeIcon: SvgWidgetFilled,
      },
      {
        label: 'menu.bot.records',
        link: assistPrefix + '/records',
        icon: SvgConversation,
        activeIcon: SvgConversationFilled,
      },
    ],
  },
  {
    group: 'SETTINGS',
    item: [
      {
        label: 'menu.bot.settings',
        link: assistPrefix + '/settings',
        icon: SvgSetting,
        activeIcon: SvgSettingFilled,
      },
    ],
  },
  {
    group: 'TRAINING',
    item: [
      {
        label: 'menu.bot.dictionary',
        link: assistPrefix + '/dictionary',
        icon: SvgDictionary,
        activeIcon: SvgDictionaryFilled,
      },
    ],
  },
];

// 导出过滤后的导航链接
export const botLinks: NavItem[] = filterNavItems(rawBotLinks);

export const getBotLinks = (hasHomepageTemplate: boolean): NavItem[] =>
  hasHomepageTemplate
    ? botLinks
    : botLinks.map((group) => ({
        ...group,
        item: group.item.filter((item) => item.link !== botPrefix + '/homepage'),
      }));
export const assistLinks: NavItem[] = filterNavItems(rawAssistLinks);

const GBASE_SUPPORT_FRONTEND_SHOW_CAPABILITY_BUTTON =
  (window as any).ENV?.GBASE_SUPPORT_FRONTEND_SHOW_CAPABILITY_BUTTON === 'true';

const capabilityBotLink: LinkItem = {
  label: 'menu.bot.capabilities',
  link: botPrefix + '/capabilities',
  icon: SvgWand,
  activeIcon: SvgWandFilled,
  showBeta: true,
};

const capabilityAssistLink: LinkItem = {
  label: 'menu.bot.capabilities',
  link: assistPrefix + '/capabilities',
  icon: SvgWand,
  activeIcon: SvgWandFilled,
  showBeta: true,
};

export const botToolLinks: NavItem[] = [
  {
    group: 'TOOLS',
    item: [
      {
        label: 'menu.bot.tool_list',
        link: botPrefix + '/tools',
        icon: SvgDictionary,
        activeIcon: SvgDictionaryFilled,
      },
      ...(GBASE_SUPPORT_FRONTEND_SHOW_CAPABILITY_BUTTON || !isLocalMode ? [capabilityBotLink] : []),
    ],
  },
];

export const assistToolLinks: NavItem[] = [
  {
    group: 'TOOLS',
    item: [
      {
        label: 'menu.bot.tool_list',
        link: assistPrefix + '/tools',
        icon: SvgDictionary,
        activeIcon: SvgDictionaryFilled,
      },
      ...(GBASE_SUPPORT_FRONTEND_SHOW_CAPABILITY_BUTTON || !isLocalMode ? [capabilityAssistLink] : []),
    ],
  },
];
